import React from 'react';
import './torListItem.scss'
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";

const TorListItem = ({text, icon, ...rest}) => {
    return <div className={'tor-list-item'}><ListItem {...rest}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={text}/>
    </ListItem></div>
}

export default TorListItem;